import { useEffect, useRef } from 'react';

import type { LocalVideoComponentProps } from '../../core/types';
import { observeShadowRoot } from './observeShadowRoot';

/**
 * Displays camera preview before joining, live video during session.
 */
export function ZoomLocalVideo({ videoProps, videoRef }: LocalVideoComponentProps) {
  const { className } = videoProps;
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const observer = observeShadowRoot(containerRef.current);
    if (!observer) {
      return;
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <video-player-container ref={containerRef} class={className}>
      <video-player ref={videoRef} style={{ width: '100%' }} />
    </video-player-container>
  );
}
